import axios from "axios";
import { apiURL } from "utils/config";
import { getAuthorizationHeaders } from "./auth";
import store from "../store";

/**
 * Returns Profile for SelectedSchool
 * @returns {AxiosPromise}
 */

export const getProspectProfile = (profileID) => {
  const schoolID = store.getState().user.selectedSchool?.id;
  if (!schoolID) return Promise.resolve({ data: null });
  const url = `${apiURL}/school/${schoolID}/prospect/${profileID}`;
  return axios({ url, method: "GET", headers: getAuthorizationHeaders() });
};
